import { useEffect } from "react";

const UTM_PARAMS = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term"] as const;
const STORAGE_KEY = "sprankelien_utm";

export interface UtmData {
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
  utm_content?: string;
  utm_term?: string;
  landing_page?: string;
  timestamp?: string;
}

/** Captures UTM params from the URL on first visit and stores them in sessionStorage. */
export function useUtmCapture() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const hasUtm = UTM_PARAMS.some((p) => params.has(p));

    if (!hasUtm) return;

    const data: UtmData = {
      landing_page: window.location.pathname,
      timestamp: new Date().toISOString(),
    };

    for (const key of UTM_PARAMS) {
      const val = params.get(key);
      if (val) data[key] = val;
    }

    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  }, []);
}

/** Returns stored UTM data (or null if none). */
export function getUtmData(): UtmData | null {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}
